import styled from 'styled-components';

export const Button = styled.button`
  width: 32px;
  height: 32px;

  .material-icons {
    font-size: 20px;
  }

  &.btn-open {
    background: ${(props) => props.theme.$gray400};
    border-color: ${(props) => props.theme.$gray400};
    color: ${(props) => props.theme.$gray800};

    &:hover,
    &:focus {
      background: ${(props) => props.theme.$gray500};
      border-color: ${(props) => props.theme.$gray500};
      color: ${(props) => props.theme.$gray800};
    }
  }
`;
